import { render } from "./zoneImage.component.vue?vue&type=template&id=463074ca"
import script from "./zoneImage.component.vue?vue&type=script&lang=js"
export * from "./zoneImage.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/etr/zones/zoneImage.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "463074ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('463074ca', __exports__)) {
    console.log('reload')
    api.reload('463074ca', __exports__)
  }
  
  module.hot.accept("./zoneImage.component.vue?vue&type=template&id=463074ca", () => {
    console.log('re-render')
    api.rerender('463074ca', render)
  })

}


export default __exports__